module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parameterInfo"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("参数设置")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "80px",
      "model": _vm.parameterForm
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "30%",
      "margin-right": "30px"
    },
    attrs: {
      "label": "参数类型",
      "prop": "parameter_type"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.parameterForm.parameter_type),
      callback: function($$v) {
        _vm.$set(_vm.parameterForm, "parameter_type", $$v)
      },
      expression: "parameterForm.parameter_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "30%",
      "margin-right": "30px"
    },
    attrs: {
      "label": "参数名称",
      "prop": "parameter_name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.parameterForm.parameter_name),
      callback: function($$v) {
        _vm.$set(_vm.parameterForm, "parameter_name", $$v)
      },
      expression: "parameterForm.parameter_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.queryFrom()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("参数信息")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddForm()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.parameterInfo,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "parameter_type",
      "label": "参数类型",
      "width": "320",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "parameter_number",
      "label": "参数编码",
      "width": "320",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "parameter_name",
      "label": "参数名称",
      "width": "320",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("\n            请选择"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(_vm.dialogStatus == 'create') ? _c('el-button', {
          attrs: {
            "type": "success"
          },
          on: {
            "click": _vm.createData
          }
        }, [_vm._v("添加")]) : _c('el-button', {
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.updateData()
            }
          }
        }, [_vm._v("保存")]), _vm._v(" "), _c('el-dropdown-item', [_c('span', {
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMap[_vm.dialogStatus],
      "visible": _vm.dialogParameterFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogParameterFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editParameterForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editParameterForm,
      "label-width": "100px",
      "rules": _vm.editParameterFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "参数类型：",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editParameterForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editParameterForm, "name", $$v)
      },
      expression: "editParameterForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "参数编码：",
      "prop": "data_sheet"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editParameterForm.data_sheet),
      callback: function($$v) {
        _vm.$set(_vm.editParameterForm, "data_sheet", $$v)
      },
      expression: "editParameterForm.data_sheet"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "参数数值：",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editParameterForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editParameterForm, "name", $$v)
      },
      expression: "editParameterForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "参数名称：",
      "prop": "data_sheet"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editParameterForm.data_sheet),
      callback: function($$v) {
        _vm.$set(_vm.editParameterForm, "data_sheet", $$v)
      },
      expression: "editParameterForm.data_sheet"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参数所属模块：",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editParameterForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.editParameterForm, "remarks", $$v)
      },
      expression: "editParameterForm.remarks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参数备注:",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editParameterForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.editParameterForm, "remarks", $$v)
      },
      expression: "editParameterForm.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateData
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogParameterFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-5e6d854c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/systemSet/parameterInfo.vue
// module id = 1680
// module chunks = 0